import React from 'react'
import { navigate } from '@reach/router'
import {
  PropertyDataContainer,
  PropertyCardContainer,
  ProposalModalContainer,
  MessageModalContainer,
  VisitScheduleModalContainer,
  SimulatorModalContainer,
} from 'containers'
import { setUtms } from 'utils/Utms'
import {
  useRoot,
  ProposalModalProvider,
  useProperty,
  VisitScheduleModalProvider,
} from 'store'
import { BaseLayout } from 'templates'
import { LinkUnavailablePage, InternalErrorPage } from 'pages'
import { usePropertyBot } from 'hooks/usePropertyBot'
import { usePageView } from 'hooks/useGAPageView'
import getWindowWidth from 'lib/windowWidth'
import { setPropertySlug } from 'utils/propertyUrl'
import styles from './Property.module.scss'

// eslint-disable-next-line react/prop-types
const PropertyPage = ({ location: { search }, city, id, preview }) => {
  usePageView()

  const { getError, setError } = useRoot()

  const { getPropertyData, clearPropertyData } = useProperty()
  let timeoutScrollDown = null
  let oldScrollPosition =
    window.pageYOffset || document.documentElement.scrollTop
  let isScrollingDown = false

  const data = getPropertyData()

  const handleScroll = () => {
    if (timeoutScrollDown) {
      clearTimeout(timeoutScrollDown)
    }

    let currentScroll = window.pageYOffset || document.documentElement.scrollTop

    timeoutScrollDown = setTimeout(() => {
      currentScroll = window.pageYOffset || document.documentElement.scrollTop
      timeoutScrollDown = null

      if (isScrollingDown && document.querySelector('#scrolleffect')) {
        document.querySelector('#scrolleffect').classList.add('scrollStopped')
      }
    }, 100)

    if (currentScroll < 120) {
      if (!isScrollingDown && document.querySelector('#scrolleffect')) {
        document
          .querySelector('#scrolleffect')
          .classList.remove('scrollStopped')
      }
    }

    isScrollingDown = currentScroll > oldScrollPosition
    oldScrollPosition = currentScroll
  }

  const handleResize = () => {
    window.removeEventListener('scroll', handleScroll)
    const windowWidth = getWindowWidth()
    if (windowWidth > 1024) {
      window.addEventListener('scroll', handleScroll)
    }
  }

  React.useEffect(() => {
    if (data && !city) {
      clearPropertyData()
      navigate(`/imovel/${setPropertySlug(data, id)}`)
    }
    if (data) window.localStorage.setItem('propertyReference', data.propertyId)
  }, [data, city, clearPropertyData, id])

  React.useEffect(() => {
    window.scrollTo(0, 0)
    setUtms(search)

    window.addEventListener('resize', handleResize)
    if (process.env.REACT_APP_STAGE === 'prod' && window.fbq) {
      window.fbq('track', 'ViewContent')
    }

    const windowWidth = getWindowWidth()
    if (windowWidth > 1024) {
      window.addEventListener('scroll', handleScroll)
    }

    return () => {
      setError(null)
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleResize)
    }
  }, []) //eslint-disable-line

  usePropertyBot()

  if (getError() === 410) return <LinkUnavailablePage />
  if (getError()) return <InternalErrorPage errorCode={getError()} />
  return (
    <BaseLayout backgroundColor="white" preview={preview}>
      <ProposalModalProvider>
        <VisitScheduleModalProvider>
          <div className={styles.wrapper}>
            <main className={styles.property}>
              <div className={styles.data}>
                <PropertyDataContainer id={id} preview={preview} />
              </div>
              <div className={styles.card}>
                <PropertyCardContainer
                  idEffect="scrolleffect"
                  preview={preview}
                />
              </div>
              <ProposalModalContainer />
              <MessageModalContainer />
              <VisitScheduleModalContainer />
            </main>
          </div>
        </VisitScheduleModalProvider>
        <SimulatorModalContainer />
      </ProposalModalProvider>
    </BaseLayout>
  )
}

export default PropertyPage
